import { compose } from 'lodash/fp'
import { ComponentType } from 'react'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import withWrapper from '../withWrapper'
import Input from './NumberInput'
import withRedux from './withRedux'

const NumberInput: ComponentType<INumberInputProps> = compose(
  FormElement,
  withWrapper,
)(Input)

const ReduxNumberInput: ComponentType<INumberInputProps> = compose(
  withReduxForm,
  withRedux,
)(NumberInput)

export default ReduxNumberInput
export { NumberInput, Input }

export interface INumberInputProps extends IFormElementProps {
  minValueForNumber?: number
  maxValueForNumber?: number
  isSmallReservation?: boolean
  autoConvert?: boolean
  countIsToLarge?: any
  withoutPicker?: boolean
  justifyCenter?: boolean
  value?: any
  normalize?: any
  wrapperSpace?: any
  afterLabel?: string
  wraping?: boolean
  onlyInteger?: boolean
  dontClampNan?: boolean
  decimal?: number
  disableMinValueOnInput?: boolean
  disabledInput?: boolean
  units?: string
}
